import {
  faPlus,
  faList,
  faTrash,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { setSelectedApp } from "../../state/appMasterSlice"
import { apiRoute, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components" 
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useDelete, useFetchWithBody } from "../../api/reactQueryCustomHooks"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"

function AppMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { mutate: deleteAppMaster } = useDelete({
    url: apiRoute.appMaster.delete,
    queryKey: "AppMaster",
  })

  /*  */
  const exportColumns = [
    { uid: "AppName", name: "App Name" },
    { uid: "AppId", name: "App Id" },
  ]

  const onClickEdit = (item) => {
    dispatch(setSelectedApp(item))
    navigate(linksUrl.appMaster.edit)
  }

  const onClickMenu = (item) => {
    dispatch(setSelectedApp(item))
    navigate(linksUrl.menuMaster.read)
  }

  const onClickDelete = (item) => {
    deleteAppMaster({ data: { appId: item.AppId } })
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.appMaster.read,
    queryKey: "AppMaster",
    inputData: {
      appId: null,
    },
  })

  const columns = [
    { uid: "AppName", name: "App Name" },
    {
      name: "ACTIONS",
      uid: "actions",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = ["AppName", "actions"]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.appMaster.add)
      },
      label: "Add App", 
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faList} />,
      onClick: onClickMenu,
      label: "Menu",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: onClickEdit,
      label: "Edit",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} />,
      onClick: onClickDelete,
      label: "Delete",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="App Master">
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          rowActionBtn={rowActionBtn}
          
          downloadFileName="App_Master"
          id="AppId"
        />
      </MainContainer>
    </div>
  )
}

export default AppMaster
